/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Synchronize } from '../../assets/themes/OPL/img/icons/Synchronize.svg';

function ReinstateButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Synchronize}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

ReinstateButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default ReinstateButton;
